"use client";

import { useState, useEffect, useContext } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

const SignInForm = () => {
  const navigate = useNavigate();
  const { user, role, login, loading: authLoading } = useContext(AuthContext);

  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  // ✅ اگر کاربر قبلاً لاگین کرده باشد، به داشبورد مربوطه هدایت شود
  useEffect(() => {
    if (user && role) {
      switch (role) {
        case "ADMIN":
          //navigate("/admin/dashboard");
          navigate("/admin/transactions");
          break;
        case "STORE":
          //navigate("/store/dashboard");
          navigate("/store/credit-requests");
          break;
        case "USER":
        default:
          //navigate("/user/dashboard");
          navigate("/user/credit-requests");
          break;
      }
    }
  }, [user, role, navigate]);

  // ✅ هندل فرم ورود
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const userData = await login({ mobile, password });
      // نقش را از userData.role یا از context می‌گیریم
      const userRole = userData.role || role;

      switch (userRole) {
        case "ADMIN":
          //navigate("/admin/dashboard");
          navigate("/admin/transactions");
          break;
        case "STORE":
          //navigate("/store/dashboard");
          navigate("/store/credit-requests");
          break;
        case "USER":
        default:
          //navigate("/user/dashboard");
          navigate("/user/credit-requests");
          break;
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError(err.response?.data?.message || "ورود ناموفق بود، لطفاً مجدد تلاش کنید.");
    } finally {
      setSubmitting(false);
    }
  };

  // اگر در حال بررسی وضعیت احراز هویت هستیم (اولین بار)
  if (authLoading) {
    return (
      <div className="text-center py-5">
        <p className="mt-3">در حال بررسی وضعیت حساب کاربری...</p>
      </div>
    );
  }

  return (
    <div className="auth-main-content m-auto m-1230 px-3">
      <Row className="align-items-center">
        <Col lg={6} className="d-none d-lg-block">
          <img
            src="/images/login.jpg"
            className="rounded-3"
            alt="login"
            width={646}
            height={804}
          />
        </Col>

        <Col lg={6}>
          <div className="mw-480 ms-lg-auto">
            {/* ✅ لوگو */}
            <div className="d-inline-block mb-4">
              <img
                src="/images/logo.svg"
                className="for-light-logo"
                alt="logo"
                width={100}
                height={26}
              />
              <img
                src="/images/white-logo.svg"
                className="for-dark-logo"
                alt="logo"
                width={100}
                height={26}
              />
            </div>

            <h3 className="fs-28 mb-2">ورود به حساب کاربری</h3>
            <p className="fw-medium fs-16 mb-4">
              شماره موبایل و رمز عبور خود را وارد کنید
            </p>

            {/* ✅ نمایش خطا */}
            {error && <div className="alert alert-danger py-2">{error}</div>}

            {/* ✅ فرم ورود */}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <label className="label text-secondary">شماره موبایل</label>
                <Form.Control
                  type="tel"
                  className="h-55"
                  placeholder="مثلاً 09121234567"
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <label className="label text-secondary">رمز عبور</label>
                <Form.Control
                  type="password"
                  className="h-55"
                  placeholder="رمز عبور"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Link
                  to="/authentication/forgot-password"
                  className="fw-medium text-primary text-decoration-none"
                >
                  رمز عبور خود را فراموش کرده‌اید؟
                </Link>
              </Form.Group>

              <Form.Group className="mb-4">
                <button
                  type="submit"
                  className="btn btn-primary fw-medium py-2 px-3 w-100"
                  disabled={submitting}
                >
                  <div className="d-flex align-items-center justify-content-center py-1">
                    <span className="material-symbols-outlined fs-20 text-white me-2">
                      {submitting ? "hourglass_empty" : "login"}
                    </span>
                    <span>{submitting ? "در حال ورود..." : "ورود"}</span>
                  </div>
                </button>
              </Form.Group>

              {/* <Form.Group>
                <p>
                  حساب کاربری ندارید؟{" "}
                  <Link
                    to="/authentication/sign-up"
                    className="fw-medium text-primary text-decoration-none"
                  >
                    ثبت‌نام کنید
                  </Link>
                </p>
              </Form.Group> */}
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignInForm;
